import React from 'react';
import { toast } from 'react-toastify';
import { getLogoutAPI } from 'src/serverApi/authorization';

type Props = {
  className?: string;
};

const LogoutLink: React.FC<Props> = ({ className = '' }) => {
  const logout = async () => {
    try {
      await getLogoutAPI();
      window.location.reload();
    } catch (error) {
      toast.error('Произошла ошибка. Попробуйте позже.');
    }
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    logout();
  };

  return (
    <a href="#" onClick={handleClick} className={className}>
      Выйти
    </a>
  );
};

export default LogoutLink;
